export default () => ({
  url: "",
  id: false,
})
